module.exports = __webpack_public_path__ + "static/img/bg-id.183d7c7b.png";